import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useUserProfile } from '@/states/user-profile';
import { devlog } from '@/libs/dev-logs';
import { getSessionToken } from '@/libs/session-management';
import { MAIN_ROUTE_BY_ROLE, RESTRICTED_ROUTES, ROUTES } from '@/router/routes';

// this hooks will subscribe to the navigation changes
export function useNavigationListener() {
  const location = useLocation();
  const navigate = useNavigate();
  const { profile, setEmail, setClinic, setRole, setAuthenticationData } = useUserProfile();

  // we need to load the user email when refresh the page and the cookie exists
  useEffect(() => {
    const token = getSessionToken();

    if (token && !profile?.email) {
      devlog('useNavigationListener: data from token session');
      setAuthenticationData(token);
    }
  }, [location, profile.email, setEmail, setClinic, setRole, setAuthenticationData]);

  // we need to redirect users based on the role if needed
  useEffect(() => {
    if (profile.email && profile.role) {
      const allowed = RESTRICTED_ROUTES[profile.role];
      if (!allowed) return;

      // for grades we could have subroutes so we handle it separately
      if (location.pathname.includes(ROUTES.GRADING) && allowed.includes(ROUTES.GRADING)) return;
      if (location.pathname.includes(ROUTES.CASES) && allowed.includes(ROUTES.NEW_CASE)) return;
      if (location.pathname.includes(ROUTES.ADMIN) && allowed.includes(ROUTES.ADMIN)) return;
      if (location.pathname.includes(ROUTES.INSIGHTS) && allowed.includes(ROUTES.INSIGHTS)) return;

      const isRestricted = !allowed.includes(location.pathname);
      if (isRestricted) {
        devlog('useNavigationListener: redirecting user to main route');
        // we need to redirect the user to the main route based on the role
        navigate(MAIN_ROUTE_BY_ROLE[profile.role]);
      }
    }
  }, [location, navigate, profile.email, profile.role]);
}
